import { useState } from 'react'

import RepaymentAmountCard from '../RepaymentAmountCard'

const RepaymentAmountList = ({ data, onSelectionChange }) => {
  // Default to second option (Minimum Due) if available
  // const defaultIndex = data?.findIndex(item => item?.title?.toLowerCase().includes('minimum due'))
  const [selectedValue, setSelectedValue] = useState(null)

  // Trigger initial selection callback
  // useEffect(() => {
  //   if (selectedValue && onSelectionChange && data) {
  //     const index = parseInt(selectedValue.split('-')[1], 10)
  //     const selectedItem = data?.[index]
  //     if (selectedItem) {
  //       onSelectionChange(selectedItem, selectedValue)
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []) // Only on mount

  const handleChange = event => {
    const value = event.target.value
    setSelectedValue(value)
    if (onSelectionChange) {
      const index = parseInt(value.split('-')[1], 10)
      const selectedItem = data?.[index]
      onSelectionChange(selectedItem, value)
    }
  }

  return (
    <div className='ew-d-flex ew-flex-column ew-gap-16'>
      {data?.map((item, index) => {
        const value = `repayment-${index}`
        const isChecked = selectedValue === value

        return (
          <RepaymentAmountCard
            checked={isChecked}
            data={item}
            key={value}
            name='repayment-option'
            onChange={handleChange}
            value={value}
          />
        )
      })}
    </div>
  )
}

export default RepaymentAmountList
